<script>
import { mapActions, mapState } from "vuex";
import SideBar from "@/components/layout/SideBar.vue";
import NavBar from "@/components/layout/NavBar.vue";
import Contactos from "@/components/contactos/Contactos.vue";
import Notificaciones from "@/components/layout/Notificaciones.vue";
import BackgroundTop from "@/assets/img/icon/section/BackgroundTop.vue";
import { EventBus } from "@/eventBus";

export default {
  components: {
    SideBar,
    NavBar,
    Contactos,
    Notificaciones,
    BackgroundTop,
  },

  data() {
    return {
      modulesLoaded: false,

      //FF
      contactoShow: false,
      notificacionesShow: false,
      heightWindow: "auto",
      logoEmpresa: "",
      logoIsotipo: "",

      toggleSidebar: false,
    };
  },

  computed: {
    ...mapState("MenuModule", ["listMenuIntranet"]),

    routeName() {
      return this.$route.name;
    },
  },

  watch: {
    listMenuIntranet(val) {
      this.modulesLoaded = val.length > 0;
    },
  },

  async created() {
    if (this.isUserLoggedIn() && typeof this.isUserLoggedIn() !== "undefined") {
      this.logoEmpresa = this.$ls.get("user").empresa[0].logo_empresa ?? "";
      this.logoIsotipo = this.$ls.get("user").empresa[0].isotipo_empresa ?? "";
      this.getModules();
      await this.getMenuSecciones();
    } else {
      if (this.routeName != "Login" && this.routeName != "Login-token")
        this.$router.push("/login");
    }

    EventBus.$on("logout", this.logOut);
    EventBus.$on('actionFn', this.actionFn);
  },

  beforeDestroy() {
    EventBus.$off("logout", this.logOut);
    EventBus.$off('actionFn', this.actionFn);
  },

  mounted() {
    //FF
    this.windowsHeight();
    window.addEventListener("resize", this.windowsHeight);
  },

  methods: {
    ...mapActions("MenuModule", ["getModulosIntranet", "getMenuEmpresa"]),

    getModules() {
      const data_ = {
        id_empresa: this.$ls.get("user").id_empresa_fk,
        id_usuario: this.$ls.get("user").id_usuario,
        id_privilegio: this.$ls.get("user").privilegio[0].id_tipo,
      };
      this.getModulosIntranet(data_);
    },

    async getMenuSecciones() {
      await this.getMenuEmpresa();
    },

    mostrarContacto() {
      this.notificacionesShow = false;
      this.contactoShow = !this.contactoShow;
    },
    enviarMensaje(contacto) {

      this.contactoShow = true;
      this.$refs.contactos.enviarMensaje(contacto);
    },
    mostrarNotificaciones() {
      this.contactoShow = false;
      this.notificacionesShow = !this.notificacionesShow;
    },

    windowsHeight() {
      let height = window.innerHeight;
      this.heightWindow = `height: ${height - 80}px`;
    },
    hexToHSL(color) {
      let textColor = color === '#FFFFFF'.toLowerCase() ? '#000000' : '#FFFFFF'
      let r = parseInt(color.substring(1, 3), 16);
      let g = parseInt(color.substring(3, 5), 16);
      let b = parseInt(color.substring(5, 7), 16);
      // Then to HSL
      r /= 255;
      g /= 255;
      b /= 255;
      let cmin = Math.min(r, g, b),
        cmax = Math.max(r, g, b),
        delta = cmax - cmin,
        h = 0,
        s = 0,
        l = 0;

      if (delta == 0) h = 0;
      else if (cmax == r) h = ((g - b) / delta) % 6;
      else if (cmax == g) h = (b - r) / delta + 2;
      else h = (r - g) / delta + 4;

      h = Math.round(h * 60);

      if (h < 0) h += 360;

      l = (cmax + cmin) / 2;
      s = delta == 0 ? 0 : delta / (1 - Math.abs(2 * l - 1));
      s = +(s * 100).toFixed(1);
      l = +(l * 100).toFixed(1);

      let hsl = h + " " + s + "% " + l + "%";
      return `
        --main-color: ${color}; 
        --main-text-color: ${textColor};
        --main-color-hsl: ${hsl}; 
        --main-color-h: ${h}; 
        --main-color-s: ${s}%; 
        --main-color-l: ${l}%;`;
    },

    sidebarCollpase() {
      this.toggleSidebar = !this.toggleSidebar;
    },
    actionFn({fn, params}) {
      this[fn](params);
    },
  },
};
</script>

<template>
  <div id="app" :style="hexToHSL(colorPrimario)">
    <main
      id="main"
      class="main"
      :class="toggleSidebar ? '' : 'main-collapse'"
      v-if="
        routeName != 'Login' && routeName != 'Login-token' && isUserLoggedIn()
      "
    >
      <SideBar
        :toggle="toggleSidebar"
        @sidebarCollpase="sidebarCollpase"
        @eventContactoShow="mostrarContacto"
        @eventNotificacionesShow="mostrarNotificaciones"
        :logoCliente="logoIsotipo"
      />
      <section class="wrapper-container">
        <NavBar
          @eventContactoShow="mostrarContacto"
          @eventNotificacionesShow="mostrarNotificaciones"
          :logoCliente="logoEmpresa"
        />
        <Contactos :show="contactoShow" ref="contactos" />
        <Notificaciones :show="notificacionesShow" />
        <section class="content-container pb-xl-0" :style="heightWindow">
          <BackgroundTop />
          <router-view :toggleSidebar="toggleSidebar" />
        </section>
      </section>
    </main>

    <main
      class="main-login"
      v-if="routeName == 'Login' || routeName == 'Login-token'"
    >
      <router-view />
    </main>
  </div>
</template>

